import { render } from "./UserAccountFee.vue?vue&type=template&id=665a98e4"
import script from "./UserAccountFee.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountFee.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/UserAccountFee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "665a98e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('665a98e4', __exports__)) {
    api.reload('665a98e4', __exports__)
  }
  
  module.hot.accept("./UserAccountFee.vue?vue&type=template&id=665a98e4", () => {
    api.rerender('665a98e4', render)
  })

}


export default __exports__